import { connect } from 'react-redux'
import Screen from './Screen'
import {toggleImageFullscreen, startAudio, validateChoices} from '../../actions/exam';

const mapStateToProps = (state, ownProps) => {
  return {
    mode: state.exam.mode,
    type: state.exam.type,
    question: state.exam.questions ? state.exam.questions[state.exam.currentQuestion || 0] : null,
    currentQuestion: state.exam.currentQuestion || 0,
    sound: state.exam.sound,
    imagesUrl: state.exam.api.imagesUrl,
    imageFullscreen: state.exam.imageFullscreen,
    showSplashScreen: state.exam.showSplashScreen,
    showComments: state.exam.showComments,
    totalTime: state.exam.questions ? state.exam.totalTime : 0,
    timeLeft: state.exam.timeLeft
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    startAudio: (questionId, sound) => dispatch(startAudio(questionId, sound)),
    toggleImageFullscreen: () => dispatch(toggleImageFullscreen()),
    validateChoices: () => dispatch(validateChoices())
  };
};

const ScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Screen);

export default ScreenContainer
